<template>
    <div>
        <v-img max-height="450" src="https://icon.irmastore.id/irma-banner/irmacapital.png"></v-img>
        <v-layout align-center justify-center>
            <v-col cols="12" lg="6" md="6">
                <v-btn block dark depressed @click="setviewstate(1)" color="green">Ajukan Sekarang</v-btn>
            </v-col>
        </v-layout>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: "pengajuan",
        data: () => ({

        }),
        computed: {
            ...mapState('Loan',['viewstate']),
        },
        methods: {
            ...mapActions('Loan',['setviewstate']),
        }
    }
</script>

<style scoped>

</style>
